import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { MessagingCardViewModel, OffersListing, RoomViewModel } from 'models';

import { MessagingCard } from 'components/common/messaging-card';
import { Room } from './room/internals/room';

export interface OfferListingsProps {
  analytics?: AnalyticsStore;
  currentHotel?: CurrentHotelStore;
  isDateless?: boolean;
  listings: OffersListing[];
  loadingOffers: boolean;
  routeStore?: RouteStore;
}

export const OffersListings: React.FunctionComponent<OfferListingsProps> = props => {
  const { analytics, currentHotel, isDateless, listings, loadingOffers, routeStore } = props;

  if (!listings || listings.length === 0) {
    return null;
  }

  let propertyUnitIndex = 0;

  return (
    <ul data-stid="section-room-list" className="no-bullet all-t-margin-one">
      {listings.map((listing, idx) => {
        switch (listing.__typename) {
          case 'MessageResult':
            return (
              <OffersListingsMessage
                key={`listing-message-${idx}`}
                analytics={analytics}
                currentHotel={currentHotel}
                message={listing as MessagingCardViewModel}
              />
            );
          case 'PropertyUnit':
            propertyUnitIndex += 1;

            return (
              <Room
                analytics={analytics}
                classList={['all-b-padding-three']}
                currentHotel={currentHotel}
                isDateless={isDateless}
                key={`listing-unit-${idx}`}
                loading={loadingOffers}
                position={`${propertyUnitIndex}`}
                room={listing as RoomViewModel}
                routeStore={routeStore}
              />
            );
          default:
            return null;
        }
      })}
    </ul>
  );
};
OffersListings.displayName = 'OffersListings';

export interface OffersListingsMessageProps {
  analytics?: AnalyticsStore;
  currentHotel?: CurrentHotelStore;
  message: MessagingCardViewModel;
  routeStore?: RouteStore;
}

export const OffersListingsMessage: React.FunctionComponent<OffersListingsMessageProps> = props => {
  const { analytics, message, routeStore } = props;

  const dataStid = `listing-message.${message.type}`;
  const bottomPadding = 'all-b-padding-three';

  // Temporary, until StandardMessagingCard can handle all actions.
  return (
    <MessagingCard analytics={analytics} className={bottomPadding} model={message} routeStore={routeStore} tag="li" testId={dataStid} />
  );
};
OffersListingsMessage.displayName = 'OffersListingsMessage';
